import { Flex, Icon, Spacing, Text, Tooltip } from '@billy/design-system'
import type { IconName } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface DocumentDetailsCardEntryProps {
  children: ReactNode
  title: string
  titleIcon?: IconName
  tooltip?: string
}

export const DocumentDetailsCardEntry = ({
  children,
  title,
  titleIcon,
  tooltip,
}: DocumentDetailsCardEntryProps): ReactElement => (
  <Styled.DocumentDetailsCardEntryWrapper>
    <Flex alignItems="stretch" flexDirection="column" gap={Spacing.S6}>
      <Flex alignItems="center" justifyContent="flex-start" gap={Spacing.S4}>
        {titleIcon && <Icon color="currentColor" icon={titleIcon} size="xs" />}
        <Text alignment="left" colorVariant="secondary" variant="bodySM">
          {title}
        </Text>
        {tooltip && (
          <Tooltip label={tooltip} placement="top">
            <Icon icon="info" size="xs" color="currentColor" />
          </Tooltip>
        )}
      </Flex>
      {children}
    </Flex>
  </Styled.DocumentDetailsCardEntryWrapper>
)
